module.exports = __webpack_public_path__ + "media/components/country-flag/static/mk-95680059debf81c8de9c105d0e45a43e.svg";